<template>
    <el-input
        v-model="value"
        size='mini'
        class="list_input"
        clearable>
    </el-input>
</template>

<script>
export default {
    data() {
        return {
            value: "",
        }
    },
    props: [ "inputValue" ],
    created() {
        this.value = this.inputValue;
    },
}
</script>

<style scoped>
.list_input{
    width: 300px;
}
</style>
